import { createContext } from "react";
import useSeguros from "../hooks/useSeguros";

const SegurosContext = createContext()

const SegurosProvider = ({ children }) => {

    const { isLoading, seguros, ramos, tiposSeguro, error } = useSeguros()

    return (
        <SegurosContext.Provider value={

            {
                isLoading,
                seguros,
                ramos,
                tiposSeguro,
                error
            }

        }>
            {children}
        </SegurosContext.Provider>
    )
}

export { SegurosContext, SegurosProvider }